import { TestType } from "types/testType";

/**
 * Model URLs interface
 */
export interface ModelUrls {
  localizationUrl: string;
  classificationUrl: string;
}


const SHARED_MODEL_URLS: ModelUrls = {
  localizationUrl: import.meta.env.VITE_HPYLORI_FOB_LOCALIZATION_MODEL_URL || '',
  classificationUrl: import.meta.env.VITE_HPYLORI_FOB_CLASSIFICATION_MODEL_URL || '',
};

/**
 * Model URLs mapped by test type
 */
export const MODEL_URLS_BY_TEST_TYPE: Record<TestType, ModelUrls> = {
  [TestType.FOB]: SHARED_MODEL_URLS,
  [TestType.HPYLORI]: SHARED_MODEL_URLS,
};

/**
 * Version JSON URLs for model metadata
 */
export const VERSION_URLS = {
  localizationVersionUrl: import.meta.env.VITE_LOCALIZATION_VERSION_URL || '',
  classificationVersionUrl: import.meta.env.VITE_CLASSIFICATION_VERSION_URL || '',
};

